import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { useIconSwapService } from './IconSwapService.jsx';

import SwapsOptionButton from './SwapsOptionButton';

import blackHouse from '../images/BlackHouse.png';
import greenHouse from '../images/GreenHouse.svg';
import greenSwaps from '../images/GreenSwaps.png';
import blackSwaps from '../images/BlackSwaps.svg';
import greenAccount from '../images/GreenAccount.png';
import blackAccount from '../images/account.svg';
import downArrow from '../images/DownArrow.svg';
import upArrow from '../images/UpArrow.png';
import helpIcon from '../images/HelpIcon.svg';
import logoutIcon from '../images/LogoutIcon.svg';
import greenHelp from '../images/GreenHelp.svg';

const swapTypes = ['AC3', 'SPORTS', 'TAP', 'WOK'];

export const MenuOptions = ({ showNav }: MenuOptionsPropTypes) => {
  const { address, logout } = useIconSwapService();
  const [homeButtonColor, setHomeButtonColor] = useState<string>('#e1f0f5');
  const [homeButtonTextColor, setHomeButtonTextColor] = useState<string>(
    '#027d81'
  );
  const [swapsButtonColor, setSwapsButtonColor] = useState<string>('#fff');
  const [swapsButtonTextColor, setSwapsButtonTextColor] = useState<string>();
  const [accountButtonColor, setAccountButtonColor] = useState<string>('#fff');
  const [accountButtonTextColor, setAccountButtonTextColor] = useState<
    string
  >();
  const [helpButtonColor, setHelpButtonColor] = useState('#fff');
  const [helpButtonTextColor, setHelpButtonTextColor] = useState<string>();
  const [isSwapsSelected, setIsSwapsSelected] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const handleClick = (button: string) => {
    if (button === 'home') {
      setHomeButtonColor('#e1f0f5');
      setSwapsButtonColor('#fff');
      setAccountButtonColor('#fff');
      setHelpButtonColor('#fff');

      setHomeButtonTextColor('#027d81');
      setSwapsButtonTextColor('#100f10');
      setAccountButtonTextColor('#100f10');
      setSwapsButtonTextColor('#100f10');

      setIsSwapsSelected(false);
      setIsMenuOpen(false);

      if (showNav) showNav();
    }

    if (button === 'swaps') {
      setHomeButtonColor('#fff');
      setSwapsButtonColor('#e1f0f5');
      setAccountButtonColor('#fff');
      setHelpButtonColor('#fff');

      setHomeButtonTextColor('#100f10');
      setSwapsButtonTextColor('#027d81');
      setAccountButtonTextColor('#100f10');
      setHelpButtonTextColor('#100f10');

      setIsSwapsSelected(!isSwapsSelected);

      setIsMenuOpen(!isMenuOpen);
    }

    if (button === 'account') {
      setHomeButtonColor('#fff');
      setSwapsButtonColor('#fff');
      setAccountButtonColor('#e1f0f5');
      setHelpButtonColor('#fff');

      setHomeButtonTextColor('#100f10');
      setSwapsButtonTextColor('#100f10');
      setAccountButtonTextColor('#027d81');
      setHelpButtonTextColor('#100f10');

      setIsSwapsSelected(false);
      setIsMenuOpen(false);
      if (showNav) showNav();
    }

    if (button === 'help') {
      setHomeButtonColor('#fff');
      setSwapsButtonColor('#fff');
      setAccountButtonColor('#fff');
      setHelpButtonColor('#e1f0f5');

      setHomeButtonTextColor('#100f10');
      setSwapsButtonTextColor('#100f10');
      setAccountButtonTextColor('#100f10');
      setSwapsButtonTextColor('#100f10');
      setHelpButtonTextColor('#027d81');

      setIsSwapsSelected(false);
      setIsMenuOpen(false);
      if (showNav) showNav();
    }
  };

  return (
    <>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <NavbarButtonWrapper>
          <NavbarDarkWidth textColor={homeButtonColor}></NavbarDarkWidth>
          <NavbarButton
            onClick={() => handleClick('home')}
            buttonColor={homeButtonColor}
            textColor={homeButtonTextColor}
          >
            <ContentWrapper>
              {homeButtonColor === '#e1f0f5' ? (
                <HouseImage src={greenHouse} alt="green house" />
              ) : (
                <HouseImage src={blackHouse} alt="black house" />
              )}
              <span>Home</span>
            </ContentWrapper>
          </NavbarButton>
        </NavbarButtonWrapper>
      </Link>
      <NavbarButtonWrapper>
        <NavbarDarkWidth textColor={swapsButtonColor}></NavbarDarkWidth>
        <NavbarButton
          onClick={() => handleClick('swaps')}
          buttonColor={swapsButtonColor}
          textColor={swapsButtonTextColor}
        >
          <ContentWrapper>
            {swapsButtonColor === '#e1f0f5' ? (
              <ArrowsImage src={greenSwaps} alt="green swaps" />
            ) : (
              <ArrowsImage src={blackSwaps} alt="black swaps" />
            )}
            <span>Swaps</span>
            {swapsButtonColor !== '#e1f0f5' ? (
              <ArrowImage src={downArrow} alt="down arrow" />
            ) : isMenuOpen ? (
              <ArrowImage src={upArrow} alt="up arrow" />
            ) : (
              <UpsideDownArrowImage src={upArrow} alt="up arrow" />
            )}
          </ContentWrapper>
        </NavbarButton>
      </NavbarButtonWrapper>
      {isSwapsSelected && (
        <div>
          {swapTypes.map((swapType) => (
            <Link
              to={`/swaps/${swapType}`}
              style={{ textDecoration: 'none' }}
              key={swapType}
            >
              <div onClick={() => (showNav ? showNav() : null)}>
                <SwapsOptionButton swapType={swapType} />
              </div>
            </Link>
          ))}
        </div>
      )}
      {address && (
        <Link to="/account" style={{ textDecoration: 'none' }}>
          <NavbarButtonWrapper>
            <NavbarDarkWidth textColor={accountButtonColor}></NavbarDarkWidth>
            <NavbarButton
              onClick={() => handleClick('account')}
              buttonColor={accountButtonColor}
              textColor={accountButtonTextColor}
            >
              <ContentWrapper>
                {accountButtonColor === '#e1f0f5' ? (
                  <AccountImage src={greenAccount} alt="green account" />
                ) : (
                  <AccountImage src={blackAccount} alt="black account" />
                )}
                <span>Account</span>
              </ContentWrapper>
            </NavbarButton>
          </NavbarButtonWrapper>
        </Link>
      )}
      <Link to="/FAQ" style={{ textDecoration: 'none' }}>
        <ResponsiveContentWrapper onClick={() => (showNav ? showNav() : null)}>
          <Help
            onClick={() => handleClick('help')}
            buttonColor={helpButtonColor}
            textColor={helpButtonTextColor}
          >
            <NavbarDarkWidth textColor={helpButtonColor}></NavbarDarkWidth>
            <ContentWrapper>
              {helpButtonColor === '#e1f0f5' ? (
                <HelpIcon src={greenHelp} alt="help" />
              ) : (
                <HelpIcon src={helpIcon} alt="help" />
              )}

              <span>Help & FAQs</span>
            </ContentWrapper>
          </Help>
        </ResponsiveContentWrapper>
      </Link>
      {address && (
        <ResponsiveContentWrapper>
          {
            // @ts-ignore
            <SignOut onClick={() => logout()}>
              <SignoutIcon src={logoutIcon} alt="signout" />
              <SignoutText>Sign out</SignoutText>{' '}
            </SignOut>
          }
        </ResponsiveContentWrapper>
      )}
    </>
  );
};

export default MenuOptions;

const NavbarButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 414px) {
    /* display: flex; */
  }
`;

const NavbarDarkWidth = styled.div`
  width: 5px;
  height: 70px;
  ${(props: ButtonToggleType) =>
    css`
      background-color: ${props.textColor === '#e1f0f5' ? '#027d81' : '#fff'};
    `}
  @media (max-width: 414px) {
    height: 62px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  @media (max-width: 414px) {
    height: 62px;
  }
`;

const ResponsiveContentWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  @media (max-width: 414px) {
    height: 62px;
  }
`;

const NavbarButton = styled.div`
  height: 70px;
  width: 100%;
  ${(props: ButtonToggleType) =>
    css`
      background-color: ${props.buttonColor};
      color: ${props.textColor ? props.textColor : '#000'};
    `};
  @media (max-width: 414px) {
    height: 62px;
  }
`;

const HouseImage = styled.img`
  margin-left: 29px;
  margin-right: 18px;
  height: 20.5px;
  width: 20.5px;
`;

const ArrowsImage = styled.img`
  margin-left: 29px;
  margin-right: 18px;
  height: 19px;
  width: 24px;
`;

const AccountImage = styled.img`
  margin-left: 29px;
  margin-right: 18px;
  height: 24px;
  width: 24px;
`;

const ArrowImage = styled.img`
  margin-right: 33px;
  height: 7px;
  width: 13px;
  margin-left: auto;
  transform: rotate(180deg);
  @media (max-width: 414px) {
    margin-right: 23px;
    height: 7px;
    width: 13px;
    margin-left: 180px;
  }
`;

const UpsideDownArrowImage = styled.img`
  margin-right: 33px;
  height: 7px;
  width: 13px;
  margin-left: auto;
  @media (max-width: 414px) {
    margin-right: 23px;
    height: 7px;
    width: 13px;
    margin-left: 180px;
  }
`;

const Help = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  bottom: 0;
  margin-bottom: 55px;
  margin-top: 25.5px;
  cursor: pointer;
  width: 100%;
  ${(props: ButtonToggleType) =>
    css`
      background-color: ${props.buttonColor};
      color: ${props.textColor ? props.textColor : '#000'};
    `};
  @media (max-width: 414px) {
    position: static;
    margin-left: 0;
    margin-bottom: 0;
    margin-top: 0;
  }
`;

const HelpIcon = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 14px;
  margin-left: 29px;
  @media (max-width: 414px) {
    margin-right: 18px;
  }
`;

const SignOut = styled.div`
  position: absolute;
  bottom: 0;
  margin-left: 35px;
  cursor: pointer;
  @media (max-width: 414px) {
    position: static;
    margin-left: 34px;
    margin-bottom: 0;
  }
`;

const SignoutIcon = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 14px;
`;

const SignoutText = styled.span``;

type ButtonToggleType = {
  buttonColor?: string;
  textColor?: string;
};

type MenuOptionsPropTypes = {
  showNav?: () => void;
};
